import React, { Component } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
import { bodyIconMap } from '../ui/icons/BodyIcons';
export function Areas() {
  const {
    t
  } = useLanguage();
  const items: {
    name: string;
    key: string;
  }[] = t('areas.items');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  return <section id="zonas" className="py-20 lg:py-28 bg-brand-cream" data-id="element-15" data-mp="23dksva7mu22p">
      <div className="container mx-auto px-6" data-id="element-16" data-mp="289i0ms4ty03v">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-17" data-mp="28cxho0i2dj7x">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-18" data-mp="2d82xqiosc3o3">
            {t('areas.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-19" data-mp="2maudguop1llj">
            {t('areas.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-20" data-mp="nwsss43ptl4d">
            {t('areas.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-21" data-mp="8hdltpf4y0zn"></div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-brand-stone/30 border border-brand-stone/30 max-w-5xl mx-auto" data-id="element-22" data-mp="8jgjmvmj4yex">
          {items.map((item, index) => {
          const IconComponent = bodyIconMap[item.key];
          return <motion.div key={item.key} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            delay: index * 0.1,
            ease: easeOutCubic
          }} className="flex flex-col items-center justify-center py-12 px-6 bg-brand-cream hover:bg-white transition-colors duration-500 text-center group" data-id="element-23" data-mp="3pywujcb6affj" data-mpi={index}>
                <div className="mb-6 text-brand-dark/30 group-hover:text-brand-gold transition-colors duration-500" data-id="element-24" data-mp="1p9r7fq8lrnqs">
                  {IconComponent && <IconComponent className="w-10 h-10" strokeWidth={1} data-id="element-25" data-mp="1taswxfcpwlfk" />}
                </div>
                <span className="text-sm font-medium tracking-widest uppercase text-brand-dark/80" data-id="element-26" data-mp="1fbbhvrp84mje">
                  {item.name}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}